import React, { useMemo } from 'react'

import {
  DemographicsCollectionFormUI,
  DemographicsCollectionFormValues,
  OTHER_LANGUAGE_NAME,
  getDefaultPreferredLanguage,
} from '~/components/screens/DemographicsCollectionFormUI'
import {
  useStates,
  usePronouns,
  useGenderIdentities,
  usePreferredLanguages,
  useBffWebOnboardingDemographicsCollection,
} from '../utils'
import { logEvent } from '~/utils/events'

const AuthenticatedDemographicsCollection: React.FC = () => {
  const states = useStates()
  const pronouns = usePronouns()
  const genderIdentities = useGenderIdentities()
  const preferredLanguages = usePreferredLanguages()

  const { handler, loading } = useBffWebOnboardingDemographicsCollection()

  const isLoading =
    pronouns.isLoading ||
    states.isLoading ||
    genderIdentities.isLoading ||
    preferredLanguages.isLoading

  const defaultPreferredLanguage = useMemo(
    () => getDefaultPreferredLanguage(preferredLanguages.data),
    [preferredLanguages.data],
  )

  const initialValues: DemographicsCollectionFormValues = {
    state: null,
    sex: null,
    gender: null,
    pronouns: null,
    preferredLanguage: defaultPreferredLanguage,
    preferredLanguageOther: '',
  }

  const handleSubmit = async (values: DemographicsCollectionFormValues) => {
    logEvent('DEMOGRAPHIC_SCREEN_COMPLETED', {})

    await handler({
      state: values.state!,
      sex: values.sex?.label || '',
      preferredLanguage: Number(values.preferredLanguage?.value) || null,
      // Optional fields
      gender: values.gender?.value ? [values.gender.value] : null,
      pronouns: values.pronouns?.label || null,
      preferredLanguageOther:
        values.preferredLanguage?.name === OTHER_LANGUAGE_NAME
          ? values.preferredLanguageOther || null
          : null,
    })
  }

  return (
    <DemographicsCollectionFormUI
      initialValues={initialValues}
      onSubmit={handleSubmit}
      isLoading={isLoading}
      submitting={loading}
      states={states.data || []}
      pronouns={pronouns.data || []}
      genderIdentities={genderIdentities.data || []}
      preferredLanguages={preferredLanguages.data}
    />
  )
}

export default AuthenticatedDemographicsCollection
